import React from "react";
import { useLocation } from "react-router-dom";

import { Icon, SubLevelLayout } from "src/components";
import {
  ariaLabel,
  PROFILE_CONFIDENTIALITY_PAGE,
  PROFILE_CREDENTIALS_PAGE,
  PROFILE_INFOS_PAGE,
  PROFILE_LANDLORD_BANKINFOS_PAGE,
  PROFILE_PAYMENTS_PAGE,
  PROFILE_PREFERENCES_PAGE,
} from "src/constants";
import SectionTitleCard from "src/containers/ProfileLayout/_components/SectionTitleCard";
import { LinkSuffix } from "src/containers/ProfileLayout/types";
import { AccountQualityEnum } from "src/graphql/generated/types";

interface Props {
  accountQuality: AccountQualityEnum;
  canSeeServices: boolean;
  children: React.ReactNode;
}

type ProfileLink = {
  label: string;
  link: LinkSuffix;
};

export const ProfileLayout = ({ accountQuality, canSeeServices, children }: Props) => {
  const paymentLink: ProfileLink =
    accountQuality === AccountQualityEnum.Landlord
      ? { label: "Mes informations bancaires", link: PROFILE_LANDLORD_BANKINFOS_PAGE }
      : { label: "Mon mode de paiement", link: PROFILE_PAYMENTS_PAGE };
  const location = useLocation();
  const { pathname } = location;

  const links: Array<ProfileLink> = [
    {
      label: "Mes identifiants",
      link: PROFILE_CREDENTIALS_PAGE,
    },
    {
      label: "Mes informations",
      link: PROFILE_INFOS_PAGE,
    },
    paymentLink,
    {
      label: "Confidentialité",
      link: PROFILE_CONFIDENTIALITY_PAGE,
    },
  ];

  const servicesLink: ProfileLink = {
    label: "Mes services",
    link: PROFILE_PREFERENCES_PAGE,
  };

  const mergedLinks: Array<ProfileLink> = canSeeServices ? [...links, servicesLink] : links;
  const sectionPath = pathname.slice(pathname.lastIndexOf("/") + 1);
  const activeSection = mergedLinks.find((link) => link.link === sectionPath)?.link;

  return (
    <SubLevelLayout
      headerIcon={<Icon name="user" />}
      headerTitle="Mon profil"
      links={mergedLinks}
      navigationAriaLabel={ariaLabel.accountNavBar}
    >
      {activeSection && <SectionTitleCard activeSection={activeSection} />}
      {children}
    </SubLevelLayout>
  );
};
